/**
 * All validation error types for campaign form fields
 */
/* eslint-disable import/prefer-default-export */
export enum CampaignValidationError {
  Required = 'Required',
  Invalid = 'Invalid'
}
